import { c as _c } from "react/compiler-runtime";
import { Form, Formik } from 'formik';
import Button from '../../../common/base/Button';
import { StyledCard, StyledCardSection } from '../../../common/base/Card';
import Container from '../../../common/base/Container';
import Divider from '../../../common/base/Divider';
import Text from '../../../common/base/Text';
import CheckboxInput from '../../../common/Form/Fields/CheckboxInput';
import SelectInput from '../../../common/Form/Fields/SelectInput';
import SwitchInput from '../../../common/Form/Fields/SwitchInput';
import TextInput from '../../../common/Form/Fields/TextInput';
import { Div } from '../../../common/helpers/StyledUtils';
import { useOutpostConfigUpdate } from '../OutpostContext';
import OperatorEventsSettings from './OperatorEventsSettings';
import { OperatorConfigUpdateInput } from '../../../../../../../typings/OutpostDeployment.interface';
const OtelSection = () => {
  const $ = _c(14);
  const {
    config,
    updateConfig
  } = useOutpostConfigUpdate();
  const has_endpoint = !!config.OTEL_EXPORTER_OTLP_ENDPOINT;
  const has_traces = !!config.OTEL_EXPORTER_OTLP_TRACES_ENDPOINT;
  const has_metrics = !!config.OTEL_EXPORTER_OTLP_METRICS_ENDPOINT;
  const has_logs = !!config.OTEL_EXPORTER_OTLP_LOGS_ENDPOINT;
  const is_enabled = has_endpoint || has_traces || has_metrics || has_logs;
  const t0 = config.OTEL_SERVICE_NAME ?? "";
  const t1 = (config.OTEL_EXPORTER_OTLP_ENDPOINT || config.OTEL_EXPORTER_OTLP_TRACES_ENDPOINT || config.OTEL_EXPORTER_OTLP_METRICS_ENDPOINT || config.OTEL_EXPORTER_OTLP_LOGS_ENDPOINT) ?? "";
  const t2 = config.OTEL_EXPORTER_OTLP_PROTOCOL ?? "";
  const t3 = config.OTEL_EXPORTER_OTLP_HEADERS ?? "";
  const t4 = has_endpoint || has_traces;
  const t5 = has_endpoint || has_metrics;
  const t6 = has_endpoint || has_logs;
  let t7;
  if ($[0] !== is_enabled || $[1] !== t0 || $[2] !== t1 || $[3] !== t2 || $[4] !== t3 || $[5] !== t4 || $[6] !== t5 || $[7] !== t6) {
    t7 = {
      otel_enabled: is_enabled,
      OTEL_SERVICE_NAME: t0,
      OTEL_EXPORTER_OTLP_ENDPOINT: t1,
      OTEL_EXPORTER_OTLP_PROTOCOL: t2,
      OTEL_EXPORTER_OTLP_HEADERS: t3,
      enable_traces: t4,
      enable_metrics: t5,
      enable_logs: t6
    };
    $[0] = is_enabled;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== updateConfig) {
    t8 = async (values_0, t9) => {
      const {
        resetForm
      } = t9;
      const updated_config = {};
      if (!values_0.otel_enabled) {
        updated_config.OTEL_SERVICE_NAME = null;
        updated_config.OTEL_EXPORTER_OTLP_ENDPOINT = null;
        updated_config.OTEL_EXPORTER_OTLP_PROTOCOL = null;
        updated_config.OTEL_EXPORTER_OTLP_HEADERS = null;
        updated_config.OTEL_EXPORTER_OTLP_TRACES_ENDPOINT = null;
        updated_config.OTEL_EXPORTER_OTLP_METRICS_ENDPOINT = null;
        updated_config.OTEL_EXPORTER_OTLP_LOGS_ENDPOINT = null;
      } else {
        updated_config.OTEL_SERVICE_NAME = values_0.OTEL_SERVICE_NAME || null;
        updated_config.OTEL_EXPORTER_OTLP_PROTOCOL = values_0.OTEL_EXPORTER_OTLP_PROTOCOL || null;
        updated_config.OTEL_EXPORTER_OTLP_HEADERS = values_0.OTEL_EXPORTER_OTLP_HEADERS || null;
        const endpoint = values_0.OTEL_EXPORTER_OTLP_ENDPOINT;
        const all_enabled = values_0.enable_traces && values_0.enable_metrics && values_0.enable_logs;
        if (all_enabled) {
          updated_config.OTEL_EXPORTER_OTLP_ENDPOINT = endpoint;
          updated_config.OTEL_EXPORTER_OTLP_TRACES_ENDPOINT = null;
          updated_config.OTEL_EXPORTER_OTLP_METRICS_ENDPOINT = null;
          updated_config.OTEL_EXPORTER_OTLP_LOGS_ENDPOINT = null;
        } else {
          updated_config.OTEL_EXPORTER_OTLP_ENDPOINT = null;
          updated_config.OTEL_EXPORTER_OTLP_TRACES_ENDPOINT = values_0.enable_traces ? endpoint : null;
          updated_config.OTEL_EXPORTER_OTLP_METRICS_ENDPOINT = values_0.enable_metrics ? endpoint : null;
          updated_config.OTEL_EXPORTER_OTLP_LOGS_ENDPOINT = values_0.enable_logs ? endpoint : null;
        }
      }
      const result = await updateConfig(updated_config, {
        success: "Monitoring settings updated",
        failure: "Failed to update monitoring settings",
        labels: {
          OTEL_SERVICE_NAME: "Service name",
          OTEL_EXPORTER_OTLP_ENDPOINT: "Endpoint",
          OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "Endpoint",
          OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "Endpoint",
          OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "Endpoint",
          OTEL_EXPORTER_OTLP_PROTOCOL: "Protocol",
          OTEL_EXPORTER_OTLP_HEADERS: "Headers"
        }
      });
      if (!result) {
        return;
      }
      const r_has_endpoint = !!result.OTEL_EXPORTER_OTLP_ENDPOINT;
      const r_has_traces = !!result.OTEL_EXPORTER_OTLP_TRACES_ENDPOINT;
      const r_has_metrics = !!result.OTEL_EXPORTER_OTLP_METRICS_ENDPOINT;
      const r_has_logs = !!result.OTEL_EXPORTER_OTLP_LOGS_ENDPOINT;
      const r_is_enabled = r_has_endpoint || r_has_traces || r_has_metrics || r_has_logs;
      resetForm({
        values: {
          otel_enabled: r_is_enabled,
          OTEL_SERVICE_NAME: result.OTEL_SERVICE_NAME ?? "",
          OTEL_EXPORTER_OTLP_ENDPOINT: (result.OTEL_EXPORTER_OTLP_ENDPOINT || result.OTEL_EXPORTER_OTLP_TRACES_ENDPOINT || result.OTEL_EXPORTER_OTLP_METRICS_ENDPOINT || result.OTEL_EXPORTER_OTLP_LOGS_ENDPOINT) ?? "",
          OTEL_EXPORTER_OTLP_PROTOCOL: result.OTEL_EXPORTER_OTLP_PROTOCOL ?? "",
          OTEL_EXPORTER_OTLP_HEADERS: result.OTEL_EXPORTER_OTLP_HEADERS ?? "",
          enable_traces: r_has_endpoint || r_has_traces,
          enable_metrics: r_has_endpoint || r_has_metrics,
          enable_logs: r_has_endpoint || r_has_logs
        }
      });
    };
    $[9] = updateConfig;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7 || $[12] !== t8) {
    t9 = <Container medium={true} left={true}><Formik enableReinitialize={true} initialValues={t7} validate={_temp} onSubmit={t8}>{_temp2}</Formik></Container>;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
};
const MonitoringSettings = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <OperatorEventsSettings />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<Div m={{
        x: 6,
        y: 6
      }}><Divider /></Div><OtelSection /></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default MonitoringSettings;
function _temp(values) {
  if (!values.otel_enabled) {
    return {};
  }
  const errors = {};
  if (!values.OTEL_SERVICE_NAME) {
    errors.OTEL_SERVICE_NAME = "Required";
  }
  if (!values.OTEL_EXPORTER_OTLP_ENDPOINT) {
    errors.OTEL_EXPORTER_OTLP_ENDPOINT = "Required";
  }
  if (!values.enable_traces && !values.enable_metrics && !values.enable_logs) {
    errors._signals = "At least one signal is required";
  }
  return errors;
}
function _temp2(props) {
  return <Form><Text bold={true} size="l" as="h2" m={{
      b: 0
    }}>OpenTelemetry</Text><Text m={{
      b: 4
    }} muted={true}>Export traces, metrics, and logs to your collector.</Text><StyledCard m={{
      b: 4
    }}><StyledCardSection flex={{
        justify: "flex-start",
        align: "center",
        gap: 3
      }} p={{
        x: 4,
        y: 3
      }}><SwitchInput name="otel_enabled" /><Text>Enable OpenTelemetry</Text></StyledCardSection>{props.values.otel_enabled && <StyledCardSection p={4}><TextInput name="OTEL_SERVICE_NAME" label="Service name" help="Identifies this deployment in your observability platform" placeholder="outpost" /><TextInput name="OTEL_EXPORTER_OTLP_ENDPOINT" label="Endpoint" help="OTLP collector URL" placeholder="https://otel-collector.example.com:4317" /><SelectInput block={true} name="OTEL_EXPORTER_OTLP_PROTOCOL" label="Protocol" options={[{
          value: "grpc",
          label: "gRPC"
        }, {
          value: "http",
          label: "HTTP"
        }]} /><TextInput name="OTEL_EXPORTER_OTLP_HEADERS" label="Headers" help="Key=Value pairs, comma-separated (e.g. Authorization=Bearer token)" placeholder="Authorization=Bearer xxx" /><Text semi={true} m={{
          b: 3
        }}>Signals</Text><Div flex={{
          gap: 6
        }} m={0}><CheckboxInput name="enable_traces" label="Traces" /><CheckboxInput name="enable_metrics" label="Metrics" /><CheckboxInput name="enable_logs" label="Logs" /></Div></StyledCardSection>}</StyledCard><Button.Permission primary={true} disabled={!props.dirty || props.isSubmitting || !props.isValid} submit={true} icon={props.isSubmitting ? "loading" : "save"}>Save</Button.Permission></Form>;
}